var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"language-switcher",attrs:{"id":_vm.propId}},[_c('Dropdown',{staticClass:"custom",attrs:{"options":_vm.sortedItems,"disabled":false,"maxItem":10,"placeholder":_vm.defaultValue ? _vm.defaultValue.name : _vm.$t('general.type_for_more')},on:{"selected":_vm.handleInput}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }